export default __webpack_public_path__ + "0f96e0b81a7c68cb4460cea4947528c8.svg";